import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import questsReducer from './slices/questsSlice';
import appealsReducer from './slices/appealsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    quests: questsReducer,
    appeals: appealsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;